import { Button } from '@ipfabric/ui-components/Button/Button';
import { ScrollView } from '@ipfabric/ui-components/ScrollView/ScrollView';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import type { FC } from 'react';

interface Props {
  content: string | null;
  onClose: () => void;
}

export const DeviceViewPathlookupDebugModal: FC<Props> = (props) => {
  if (props.content === null) {
    return null;
  }

  return (
    <OverlayModal onClose={props.onClose} size='content-default'>
      <OverlayModalBody className='pb-0'>
        <ScrollView
          autoHeight
          autoHeightMax='calc(100vh - 150px)'
          contentClassName='pr-2'
        >
          <pre className='whitespace-pre-wrap break-all font-mono text-xs leading-5'>
            {props.content}
          </pre>
        </ScrollView>
      </OverlayModalBody>
      <OverlayModalFooter>
        <div className='text-right'>
          <Button type='button' variant='outline' onClick={props.onClose}>
            Close
          </Button>
        </div>
      </OverlayModalFooter>
    </OverlayModal>
  );
};
